import React, { useState } from 'react';
import { Query, Mutation } from 'react-apollo';
import gql from 'graphql-tag';
import {
  Card, Container, Grid, Button, Form,
} from 'tabler-react';
import { AuthFunctions } from '../auth/Auth';


const CURRENT_USER = gql`
query currentUser {
  currentUser {
    email
  }
}
`;

const CHANGE_EMAIL = gql`
mutation changeEmail($email : String!) {
  changeEmail(email: $email)
}
`;


const ChangeEmail = ({ email }) => {
  const [disabled, setDisabled] = useState(true);
  const [emailVal, setEmail] = useState(email);
  const [error, setError] = useState(null);

  let Error = null;
  if (error) {
    Error = <span className="invalid-feedback">{error}</span>;
  }
  return (
    <Form.Group label="User Details">
      <Form.InputGroup>
        <Form.Input
          className={error && 'is-invalid'}
          disabled={disabled}
          name="email"
          type="email"
          value={emailVal}
          onChange={(({ target: { value } }) => setEmail(value))}
        />
        <Form.InputGroupAppend>
          <Button
            RootComponent="button"
            color="primary"
            onClick={() => setDisabled(!disabled)}
          >
              Edit
          </Button>
          <Mutation mutation={CHANGE_EMAIL}>
            {changeEmail => (
              <Button
                RootComponent="button"
                color="success"
                disabled={disabled}
                onClick={async () => {
                  if (emailVal === email) return setDisabled(true);
                  try {
                    const result = await changeEmail({ variables: { email: emailVal } });
                    if (result.data && result.data.changeEmail) {
                      setDisabled(true);
                      setError(null);
                    }
                  } catch (e) {
                    setError(e.message);
                  }
                }}
              >
                  Save
              </Button>
            )}
          </Mutation>
        </Form.InputGroupAppend>
        {Error}
      </Form.InputGroup>
    </Form.Group>

  );
};

const RequestPasswordReset = ({ email }) => (
  <AuthFunctions>
    {({ resetPassword }) => (
      <Button outline block color="primary" onClick={() => resetPassword({ email })}>
            Request Password Reset
      </Button>
    )}
  </AuthFunctions>
);

const UserDetails = props => (
  <Grid.Col lg={6}>
    <ChangeEmail {...props} />
    <RequestPasswordReset {...props} />
  </Grid.Col>
);

const Profile = () => (
  <Container className="my-3">
    <Grid.Row>
      <Grid.Col lg={12}>
        <Card
          title="Profile"
          body={(
            <Query query={CURRENT_USER}>
              {({ data: { currentUser = {} } = {} }) => {
                if (currentUser && currentUser.email) return <UserDetails email={currentUser.email} />;
                return null;
              }}
            </Query>

            )}
        />
      </Grid.Col>
    </Grid.Row>
  </Container>
);

export default Profile;



// WEBPACK FOOTER //
// ./src/profile/index.js